import {
  XYChart,
  DateAxis,
  ValueAxis,
  XYCursor,
  LineSeries,
  Legend,
} from "@amcharts/amcharts4/charts";
import * as amCore from "@amcharts/amcharts4/core";

import { AxisRange } from "../models";

import {
  signalLabel,
  TOOLTIP_FORMAT,
  DATE_FORMAT,
  NUMBER_FORMAT,
} from "../common";
import { appConfigs } from "../../../../utils/configurations";

export interface Options {
  axisRange?: AxisRange;
  rightYAxisRange?:AxisRange;
  enableRightYAxis?: boolean;
}

export type TimeSeriesSignal = {
  name: string;
  units: string;
  values: Array<{ timestamp: Date; value: number }>;
};

class LineChart {
  private _chart: XYChart;
  private  count = 0 ;
  constructor(ref: HTMLDivElement, series: TimeSeriesSignal[],rightAxisSeries:TimeSeriesSignal[], opts?: Options) {
    const chart = amCore.create(ref, XYChart);
  
    const xAxis = chart.xAxes.push(new DateAxis());
    xAxis.cursorTooltipEnabled = false;

    const yAxis = chart.yAxes.push(new ValueAxis());
    yAxis.cursorTooltipEnabled = false;
    yAxis.min = opts?.axisRange?.min;
    yAxis.max = opts?.axisRange?.max;

    const cursor = (chart.cursor = new XYCursor());
    cursor.lineY.disabled = true;
    // Show only one tooltip
    // https://www.amcharts.com/docs/v4/concepts/chart-cursor/#Relation_to_series
    cursor.maxTooltipDistance = -1;

    chart.legend = new Legend();
    chart.legend.itemContainers.template.paddingTop = 1;
    chart.legend.itemContainers.template.paddingBottom = 1;
    chart.legend.itemContainers.template.paddingLeft=1;
    chart.legend.itemContainers.template.paddingRight=1;
    chart.legend.itemContainers.template.tooltipText="{name}";

    chart.dateFormatter.dateFormat = DATE_FORMAT;
    chart.numberFormatter.numberFormat = NUMBER_FORMAT;
  
    this._chart = chart;
   
    series.forEach(this.addSeries);
    
    if(opts?.enableRightYAxis){
      //right value axis
      const rightYAxis = chart.yAxes.push(new ValueAxis());
      rightYAxis.cursorTooltipEnabled = false;
      rightYAxis.min = opts?.rightYAxisRange?.min;
      rightYAxis.max = opts?.rightYAxisRange?.max;
      rightYAxis.renderer.opposite = true;
      rightAxisSeries.forEach(item=>this.addRightAxisSeries(item,rightYAxis))
   }    
    
  }
   
  addSeries = (dataSeries: TimeSeriesSignal) => {

    const series = new LineSeries();
   
    series.dataFields = {
      valueY: "value",
      dateX: "timestamp",
    };
    series.data = dataSeries.values;     
    series.strokeWidth = 2;
    
    series.stroke = amCore.color(appConfigs.colorCodes.colorCodesLineChart[this.count]);
       
    series.name = signalLabel(dataSeries);
    series.tooltipText = TOOLTIP_FORMAT;

    this._chart.series.push(series);

    this.count++;
  };

  addRightAxisSeries=(dataSeries: TimeSeriesSignal,rightYAxis:ValueAxis)=>{
    const series2 = new LineSeries();
   
    series2.dataFields = {
      valueY: "value",
      dateX: "timestamp",
    };
    series2.data = dataSeries.values;      
    series2.strokeWidth = 2;
    
    series2.stroke = amCore.color(appConfigs.colorCodes.colorCodesLineChart[this.count]);
       
    series2.name = signalLabel(dataSeries);
    series2.tooltipText = TOOLTIP_FORMAT;
    
    series2.yAxis=rightYAxis;

    this._chart.series.push(series2);

    this.count++;
  }

  destroy() {
    this._chart?.dispose();
  }
}

export default LineChart;